import { getSidebarActions } from "../actions/sidebarActions";


export const useSidebarActions = (t, nodes) => {
  return getSidebarActions(t, nodes);
};
